import React from 'react';
import { format } from 'date-fns';
import { Icon } from '@/components/shared/display/Icon';
import { ChevronRightIcon } from '@/assets/Icons';

export const ActiveMonthLink = ({ activeMonth }: { activeMonth: string | null }) => {
  return activeMonth ? (
    <>
      <Icon icon={ChevronRightIcon} className="w-5 h-5" />
      <div className="font-semibold text-sm">
        {format(new Date(activeMonth), 'LLL yyyy')}
      </div>
    </>
  ) : null;
};
